import React from 'react';
import { AuthProvider, useAuth } from '../../context/AuthContext';
import { ThemeProvider } from '../../context/ThemeContext';
import CRMLogin from './CRMLogin';
import CRMLayout from './CRMLayout';
import { Loader2 } from 'lucide-react';

const CRMContent = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <Loader2 className="w-8 h-8 animate-spin text-amber-500" />
      </div>
    );
  }

  return isAuthenticated ? <CRMLayout /> : <CRMLogin />;
};

const CRM = () => {
  return (
    <AuthProvider>
      <ThemeProvider>
        <CRMContent />
      </ThemeProvider>
    </AuthProvider>
  );
};

export default CRM;
